<script lang="ts" setup>
  import { Logo } from '../../../shared/ui/logo';
  import { MobileViewLayout } from '../../../shared/ui/mobile-view-layout';

  defineProps<{ secondsLeft: string }>();
</script>

<template>
  <MobileViewLayout justify="center">
    <Logo class="logo" />
    <p class="label">Game starting in</p>
    <h1 class="countdown">{{ secondsLeft }}</h1>
  </MobileViewLayout>
</template>

<style scoped>
  .logo {
    margin-bottom: 1rem;
  }

  .label {
    color: var(--color-text-muted);
    font-size: var(--font-size-md);
    letter-spacing: 0.1rem;
    margin: 0;
    text-transform: uppercase;
  }

  .countdown {
    color: var(--color-primary);
    font-family: var(--font-display);
    font-size: var(--font-size-5xl);
    line-height: 1;
    margin: 0;
  }
</style>
